import React from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import SetupChecklist from "app/components/AcademySetup/SetupChecklist";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import { isAcademyOnboardingCoach } from "app/utils/subscription";
import { FeedTimelineModel } from "./indexModel";
import TimelinePostsContainer from "app/components/TimelinePostsContainer";
import FeedPostingForm from "../FeedPostingForm";
import PostReportModal from "app/components/Post/InnerPost/PostReportModal";
import Filter from "app/components/Filter";
import CreatedScheduledPostModal from "app/components/CreatedScheduledPostModal";
import Navbar from "app/components/Navbar";
import { useTranslation } from "react-i18next";

const FeedTimeline = () => {
  const {
    data,
    onPost,
    pending,
    reportModal,
    reportModalClose,
    onReportHandler,
    onPostReportClick,
    onPostDelete,
    onPostUpdate,
    sentryRef,
    filterHandler,
    onClearFilters,
    newScehduleModalOpen,
    handleNewSchedulePost,
    scheduledAt,
  } = FeedTimelineModel();

  const { t } = useTranslation();
  const { self } = useSelector((state: RootState) => state.user, shallowEqual);
  // Same gate as SetupChecklist, so banner and checklist agree on who is
  // onboarding. Facility staff on the Academy plan get neither surface: the
  // legacy banner hides itself on the plan.
  const academyChecklist = isAcademyOnboardingCoach(self);

  return (
    <>
      <Navbar label={t("Feed")} hasSearch hasNotifications={false} />
      {academyChecklist ? <SetupChecklist banner /> : <GettingStartedProgress />}
      <div className={styles.content_container}>
        <FeedPostingForm onPost={onPost} />
        <div className={styles.dropdown_container}>
          <hr />
          <Filter
            filterClickHandler={filterHandler}
            onFilterClear={onClearFilters}
          />
        </div>
        <TimelinePostsContainer
          displayPostLocations
          hidePinBadge
          onPostDelete={onPostDelete}
          onPostUpdate={onPostUpdate}
          onReport={onPostReportClick}
          containerRef={sentryRef}
          posts={data}
          pending={pending}
          canPinPost={false}
        />
        {reportModal.isOpen && (
          <PostReportModal
            isModalOpen={reportModal.isOpen}
            modalHandler={reportModalClose}
            reportHandler={onReportHandler}
          />
        )}
        {newScehduleModalOpen && (
          <CreatedScheduledPostModal
            isOpen={newScehduleModalOpen}
            onClose={handleNewSchedulePost}
            redirectUrl={"/schedule"}
            scheduledAt={scheduledAt}
          />
        )}
      </div>
    </>
  );
};

export default FeedTimeline;
